import styled from 'styled-components';
import { layout } from 'Constants';

export default styled.div`
  display: flex;
  ${props => props.wrap && 'flex-wrap: wrap'};
  ${props => props.column && 'flex-direction: column'};
  ${props =>
    props.alignItems &&
    `align-items: ${
      typeof props.alignItems === 'string' ? props.alignItems : 'center'
    }`};
  ${props =>
    props.justifyContent &&
    `justify-content: ${
      typeof props.justifyContent === 'string' ? props.justifyContent : 'center'
    }`};
  ${props => props.margin && `margin: ${props.margin}`};
  ${props => props.maxWidth && `max-width: ${layout.maxWidth}`};

  > * {
    ${props => props.seperation && `margin: 0`};
    align-self: stretch;
  }

  > * + * {
    ${props =>
      props.seperation && props.column && `margin-top: ${props.seperation}`};
    ${props =>
      props.seperation && !props.column && `margin-left: ${props.seperation}`};
  }
`;
